import React from "react"

export const SearchIcon = () => (
  <svg
    height="28"
    viewBox="0 0 26 28"
    width="26"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="m3.28819721 12.0328205c0-4.76717947 3.7940737-8.6728205 8.48748339-8.6728205 4.6934097 0 8.4593791 3.90564103 8.4593791 8.6728205 0 4.7671795-3.7940737 8.6728205-8.4593791 8.6728205-4.66530544 0-8.48748339-3.8769231-8.48748339-8.6728205m22.23046149 13.0953846-4.9744522-5.0830769c1.8548805-2.1251282 3.0071547-4.9394872 3.0071547-8.0123077 0-6.63384614-5.2835989-12.0328205-11.7756806-12.0328205-6.49208167 0-11.7756806 5.39897436-11.7756806 12.0328205 0 6.6338462 5.28359893 12.0328205 11.7756806 12.0328205 2.3045485 0 4.4404714-.6892307 6.2391434-1.8379487l5.1711819 5.2841026c.3091468.3158974.7307105.4882051 1.1522743.4882051.4215637 0 .8431275-.1723077 1.1522742-.4882051.674502-.6605128.674502-1.723077.0281043-2.3835898"
      fillRule="evenodd"
    />
  </svg>
)



// WEBPACK FOOTER //
// /opt/build/repo/src/components/Icons/SearchIcon.js